





















import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import { ICurrentValidatorRes } from '@/services/currentValidator/model'

@Component({
    components: {},
})
export default class Validators extends Vue {
    get currentValidators(): ICurrentValidatorRes {
        return this.$root.$store.state.Metrics.currentValidators
    }

    get validatorsUptime() {
        let totalUptime = 0
        this.currentValidators.validators.map((vali) => {
            totalUptime += parseFloat(vali.uptime)
        })

        return (totalUptime / this.currentValidators.validators.length) * 100
    }
}
